import {
  Component,
  inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { ISession } from '@core/models-v2/auth/session.interface';
import { IOrderDetail } from '@core/models-v2/cart/order-details.interface';
import { CartService } from '@core/services-v2/cart.service';
import { PaymentMethodPurchaseOrderRequestService } from '@core/services-v2/payment-method-purchase-order-request.service';
import { SessionService } from '@core/services-v2/session/session.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { UserRoleType } from '@core/enums/user-role-type.enum';
import { CartApiService } from '@core/services-v2/cart/cart-api/cart-api.service';
import { SalesOrderApiService } from '@core/services-v2/sales-order/sales-order-api/sales-order-api.service';
import { TableLazyLoadEvent } from 'primeng/table';
import { ShoppingCartStatusType } from '@core/enums/shopping-cart-status.enum';
import { ScreenService } from '@shared/services/screen';

@Component({
  selector: 'app-purchase-request',
  templateUrl: './purchase-request.component.html',
  styleUrls: ['./purchase-request.component.scss'],
})
export class PurchaseRequestComponent implements OnInit {
  private readonly screenService = inject(ScreenService);

  isMobile = this.screenService.isMobile;

  @ViewChild('modalApprove', { static: false })
  modalApprove!: TemplateRef<any>;
  modalApproveRef!: BsModalRef;
  @ViewChild('modalRefuse', { static: false }) modalRefuse!: TemplateRef<any>;
  modalRefuseRef!: BsModalRef;
  isDetailVisible: boolean = false;
  usuario!: ISession;
  orders!: IOrderDetail[];
  title: string = '';
  viewActive = 'list';
  orderId: string = '';
  order!: IOrderDetail;
  loadingPage: boolean = false;
  obsRefuse: string = '';
  userRoles = UserRoleType;
  totalRows: number = 0;
  rows: number = 10;
  first: number = 0;
  loadingData: boolean = true;

  private readonly cartApiService = inject(CartApiService);
  private readonly salesOrderApiService = inject(SalesOrderApiService);

  constructor(
    private router: Router,
    private modalService: BsModalService,
    private toast: ToastrService,
    private readonly sessionService: SessionService,
    private readonly cartService: CartService,
    private readonly paymentPurchaseOrderService: PaymentMethodPurchaseOrderRequestService
  ) {}

  ngOnInit(): void {
    this.usuario = this.sessionService.getSession();
    if (!this.usuario.hasOwnProperty('username'))
      this.usuario.username = this.usuario.email;
    this.title = 'Solicitudes de compra pendientes de aprobación';
    this.loadPrimeTableData();
  }

  reloadPage() {
    this.loadPrimeTableData();
  }

  loadPrimeTableData(event?: TableLazyLoadEvent) {
    this.first = event?.first || 0;
    this.rows = event?.rows || this.rows;
    this.loadingData = true;
    let params = {
      user: this.usuario.username || '',
      salesDocumentType: 2,
      statuses: [
        ShoppingCartStatusType.PENDING,
        ShoppingCartStatusType.REJECTED,
      ],
      page: this.first / this.rows + 1,
      limit: this.rows,
      sort: '_id|-1',
    };
    this.salesOrderApiService.getOrderDetails(params).subscribe({
      next: (res) => {
        this.orders = res.data.map((order) => ({
          ...order,
          purchaseOrderNumber: order.purchaseOrder?.number || 'No definido',
          purchaseOrderAmount: order.purchaseOrder?.amount || 0,
        }));
        this.totalRows = res.total;
        this.loadingData = false;
      },
      error: (err) => {
        console.error('Error al cargar los datos:', err);
      },
    });
  }

  viewOrderDetail(item: IOrderDetail) {
    this.viewActive = 'detail';
    this.orderId = item.id;
    this.order = item;
  }

  backToList() {
    this.viewActive = 'list';
  }

  approveOrder(item: any) {
    this.modalApproveRef = this.modalService.show(this.modalApprove);
    this.order = item;
  }

  confirmApproveOrder() {
    this.loadingPage = true;
    this.modalApproveRef.hide();
    this.paymentPurchaseOrderService.approve(this.order.id).subscribe({
      next: (res) => {
        this.loadingPage = false;
        let params = {
          paymentMethod: 'OC',
          shoppingCartId: this.order.id || res.shoppingCartId,
          shoppingCartNumber: res.shoppingCartNumber,
          status: 'approved',
        };

        this.cartService.load();
        this.router.navigate(['/', 'carro-compra', 'gracias-por-tu-compra'], {
          queryParams: { ...params },
        });
      },
      error: (err) => {
        console.log(err);
        this.toast.error('Ha ocurrido  al generar la orden de venta');
      },
    });
  }

  refuseOrder(item: any) {
    this.modalRefuseRef = this.modalService.show(this.modalRefuse);
    this.order = item;
  }

  confirmRefuseOrder() {
    this.loadingPage = true;
    this.cartApiService.updateStatus(this.order.id, 'rejected').subscribe({
      next: () => {
        this.loadingPage = false;
        this.toast.success('Solitud rechazada correctamente');
        this.modalRefuseRef.hide();
        this.obsRefuse = '';
        this.loadPrimeTableData();
      },
      error: (err) => {
        this.toast.error('Ha ocurrido un error al rechazar la orden de venta');
      },
    });
  }
}
